// extracted by mini-css-extract-plugin
export var localeSelector = "_43-0";